<div class="top-title-bar">
  <h2 class="page-title">Home</h2>
</div>
<div class="white-box">
  <div id="reportsContainer" [style.height.px]="reportHeight"></div>
</div>